import { getDesignationIdsFromChannelMemberRecord } from "Messenger/hooks/channelData.helpers";

export const getFullName = (data) => {
  const { name, firstName, lastName } = data || {};
  if (name) {
    return name;
  }
  if (firstName || lastName) {
    return `${firstName} ${lastName}`;
  }
};

export const inBytes = (inMbs) => inMbs * 1024 * 1024;

/**
 * Designation id(s) on a single `GetDistinctUsersByOwnerId` row (supports
 * array + legacy singular fields and common PascalCase API shapes).
 * @param {Record<string, unknown>} item
 * @returns {number[]}
 */
const getDesignationIdsFromStaffListRow = (item) =>
  getDesignationIdsFromChannelMemberRecord({
    designationIds: item?.designationIds ?? item?.DesignationIds,
    designationId:
      item?.designationId ??
      item?.DesignationId ??
      item?.role?.id ??
      item?.Role?.id,
    designation: item?.designation ?? item?.Designation,
  });

/**
 * Merges staff rows returned from `GetDistinctUsersByOwnerId` into a single object
 * per `userId` with aggregated `officeIds` and `designationIds` for messenger
 * selection and channel metadata.
 * @param {Array<Record<string, unknown>>} rows
 * @returns {Array<Record<string, unknown>>}
 */
export const mergeStaffListRowsByUserId = (rows) => {
  if (!Array.isArray(rows) || !rows.length) return [];
  const map = new Map();
  for (const item of rows) {
    const uidRaw =
      item.userId ??
      item.UserId ??
      item.user?.id ??
      item.id ??
      item.Id;
    if (uidRaw == null || uidRaw === "") continue;
    const mapKey = String(uidRaw);
    const rowDesignations = getDesignationIdsFromStaffListRow(item);
    const officeId = item.officeId ?? item.OfficeId;
    const existing = map.get(mapKey);
    if (!existing) {
      const officeIds =
        officeId != null && officeId !== ""
          ? [Number(officeId)].filter((n) => !Number.isNaN(n))
          : [];
      const designationIds = [...new Set(rowDesignations)];
      map.set(mapKey, {
        ...item,
        userId: uidRaw,
        officeIds,
        designationIds,
      });
      continue;
    }
    if (officeId != null && officeId !== "") {
      const n = Number(officeId);
      if (!Number.isNaN(n) && !existing.officeIds.includes(n)) {
        existing.officeIds.push(n);
      }
    }
    for (const d of rowDesignations) {
      if (!existing.designationIds.includes(d)) {
        existing.designationIds.push(d);
      }
    }
  }
  return Array.from(map.values());
};
